export const GET_TOKEN_REQUEST = "GET_TOKEN_REQUEST";
export const SET_TOKEN_SUCCESS = "SET_TOKEN_SUCCESS";
export const GET_TOKEN_SUCCESS = "GET_TOKEN_SUCCESS";
export const REMOVE_TOKEN_REQUEST = "REMOVE_TOKEN_REQUEST";
export const GET_LOGIN_REQUEST = "GET_LOGIN_REQUEST";
